





























































































































import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { useNamespacedStore } from '~/compositions/store'
import CClassifiedFavoriteButton from '~/components/shared/configurable/classified/bucket/favorite/CClassifiedFavoriteButton.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import MarketplaceProductAvailabilityBadge from '~/components/car/marketplace/product/MarketplaceProductAvailabilityBadge.vue'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import { formatPrice } from '~/utils/number'
import { ciCart } from '~/icons/source/solid/cart'
import MarketplaceSellerModalTrigger from '~/components/car/marketplace/seller/MarketplaceSellerModalTrigger.vue'
import { ciShipping } from '~/icons/source/regular/shipping'
import { ciEshop } from '~/icons/source/regular/e-shop'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { ciMinus } from '~/icons/source/light/minus'
import { ciPlus } from '~/icons/source/light/plus'
import MarketplaceSectionCartButton from '~/components/car/classifieds/view/partials/MarketplaceSectionCartButton.vue'

export default defineComponent({
  components: {
    MarketplaceSectionCartButton,
    CPrice,
    MarketplaceProductAvailabilityBadge,
    CClassifiedFavoriteButton,
    MarketplaceSellerModalTrigger,
    CCard
  },
  setup() {
    const {
      state: classifiedViewState,
      dispatch: classifiedViewDispatch
    } = useNamespacedStore<ClassifiedViewState>(CLASSIFIED_VIEW_NS)
    const { state: userState } = useNamespacedStore<UserState>(USER_NS)

    const loading = ref(false)

    const marketplace = computed(() => classifiedViewState.marketplace)

    const classified = computed(() => classifiedViewState.classified)

    const currentUser = computed(() => classifiedViewState.currentUser)

    const currentUserId = computed(() => userState.id)

    function onClassifiedParkedChange(isParked: boolean) {
      classifiedViewDispatch('classifiedParkedStateChanged', isParked)
    }

    return {
      ciCart,
      ciShipping,
      ciEshop,
      faEdit,
      ciPlus,
      ciMinus,
      marketplace,
      classified,
      currentUser,
      loading,
      currentUserId,
      formatPrice,
      onClassifiedParkedChange
    }
  },
  i18n: defineComponentTranslations({
    classified_number: {
      en: 'Classified number',
      el: 'Αρ. αγγελίας'
    },
    add_to_cart: {
      en: 'Add to cart',
      el: 'Προσθήκη στο καλάθι'
    },
    sold_by: {
      en: 'Sold by',
      el: 'Πωλείται από'
    },
    edit_product: {
      en: 'Edit product',
      el: 'Επεξεργασία προϊόντος'
    },
    item_added_to_cart: {
      en: 'Item added to cart',
      el: 'Το προϊόν προστέθηκε στο καλάθι'
    },
    ability_to_pickup_from_store: {
      en: 'Ability to pickup from store',
      el: 'Δυνατότητα παραλαβής από κατάστημα'
    }
  })
})
